import {
  fetchSingleStockUnitRoutine,
  fetchStockUnitHistoryRoutine,
  fetchStockUnitKindsRoutine,
  fetchStockUnitsRoutine
} from 'modules/stockUnits/ducks/actions'

const defaultState = {
  list: [],
  pagination: null,
  currentStockUnit: {},
  stockUnitKindList: [],
  stockUnitHistoryList: [],
  stockUnitHistoryListPagination: null,
  isLoading: false,
  isLoadingStockUnitKindList: false,
  isLoadingStockUnitHistoryList: false,
  isLoadingCurrentStockUnit: false
}

const stockUnitsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case fetchStockUnitsRoutine.TRIGGER:
      return {
        ...state,
        isLoading: true
      }
    case fetchStockUnitsRoutine.FAILURE:
      return {
        ...state,
        isLoading: false
      }
    case fetchStockUnitsRoutine.SUCCESS:
      return {
        ...state,
        list: action.payload.data,
        pagination: {
          itemsCount: action.payload.meta.total,
          totalPages: action.payload.meta.lastPage,
          perPage: action.payload.meta.perPage,
          currentPage: action.payload.meta.currentPage
        },
        isLoading: false
      }
    case fetchSingleStockUnitRoutine.TRIGGER:
      return {
        ...state,
        isLoadingCurrentStockUnit: true
      }
    case fetchSingleStockUnitRoutine.FAILURE:
      return {
        ...state,
        isLoadingCurrentStockUnit: false
      }
    case fetchSingleStockUnitRoutine.SUCCESS:
      return {
        ...state,
        currentStockUnit: action.payload,
        isLoadingCurrentStockUnit: false
      }
    case fetchStockUnitHistoryRoutine.TRIGGER:
      return {
        ...state,
        isLoadingStockUnitHistoryList: true
      }
    case fetchStockUnitHistoryRoutine.FAILURE:
      return {
        ...state,
        isLoadingStockUnitHistoryList: false
      }
    case fetchStockUnitHistoryRoutine.SUCCESS:
      return {
        ...state,
        stockUnitHistoryList: action.payload.data,
        stockUnitHistoryListPagination: {
          itemsCount: action.payload.meta.total,
          totalPages: action.payload.meta.lastPage,
          perPage: action.payload.meta.perPage,
          currentPage: action.payload.meta.currentPage
        },
        isLoadingStockUnitHistoryList: false
      }
    case fetchStockUnitKindsRoutine.TRIGGER:
      return {
        ...state,
        isLoadingStockUnitKindList: true
      }
    case fetchStockUnitKindsRoutine.FAILURE:
      return {
        ...state,
        isLoadingStockUnitKindList: false
      }
    case fetchStockUnitKindsRoutine.SUCCESS:
      return {
        ...state,
        stockUnitKindList: action.payload.data,
        isLoadingStockUnitKindList: false
      }
    default:
      return state
  }
}

export default stockUnitsReducer
